import {thumbsDownSvg as Icon__small__thumbsDownSvg} from '../Icon__small/Icon__small--thumbsDown.js';
import {thumbsDownSvg as Icon__xsmall__thumbsDownSvg} from '../Icon__xsmall/Icon__xsmall--thumbsDown.js';

export var thumbsDown = {
  name: 'thumbsDown',
  category: 'icon',
  colorable: true,
  svg: Icon__small__thumbsDownSvg,
  alt: {
    Icon__small: Icon__small__thumbsDownSvg,
    Icon__xsmall: Icon__xsmall__thumbsDownSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
